import "core-js/modules/es6.object.assign";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";

/*********封装packageTable mixins 的基本数据*******/
import packageTable from '@/components/tables/packageTable';
export default {
  data: function data() {
    return {
      showHeader: false,
      tableLoading: false,
      //tableloading 表格loading状态
      reduceheight: 60,
      //默认需要 减去的高度
      selectTabelList: [],
      //table选中项
      reqBase: {
        //请求的base参数
        isPage: true,
        page: 1,
        page_size: 15
      },
      getPageTotal: 0,
      //页面数据总数量
      getadvancedSearchModal: false,
      //searchpanel 状态
      tableDataList: [],
      //填充的数据
      customerList: [],
      functionRole: []
    };
  },
  components: {
    packageTable: packageTable
  },
  methods: {
    /**
     * 从本地取pageSize
     */
    getPageSizeToStorage: function getPageSizeToStorage() {
      var pageSize = localStorage.getItem('pageSize');

      if (pageSize) {
        this.$set(this.reqBase, 'page_size', parseInt(pageSize));
      }
    },

    /**
     * 获取页面功能权限
     */
    getFunctionRole: function getFunctionRole() {
      this.functionRole.splice(0);
      var route = this.$route.path;
      var roleList = localStorage.getItem('apiRole');

      if (roleList) {
        var apiRole = JSON.parse(roleList);

        if (apiRole.hasOwnProperty(route)) {
          var _this$functionRole;

          (_this$functionRole = this.functionRole).push.apply(_this$functionRole, _toConsumableArray(apiRole[route]));
        }
      }
    },
    pageSizeChange: function pageSizeChange(pageSize) {
      this.reqBase.page_size = pageSize;
      this.init();
    },
    //选择所选项
    getSelectList: function getSelectList(section) {
      this.selectTabelList = section;
    },
    //页码change
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.init();
    },

    /**
     * 点击search
     */
    showSearchParel: function showSearchParel() {
      this.getadvancedSearchModal = true;
      this.$refs.filterBaseSearch.init();
    },

    /**
     * search 时请求参数的拼装
     * @param params
     */
    onSearch: function onSearch(params) {
      //重置当前页为1
      this.reqBase.page = 1;
      Object.assign(this.reqBase, params); //重置当前的page

      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },
    //搜索框——查询客户名称函数
    queryCustomerNameHandle: function queryCustomerNameHandle(customerName) {
      var _this = this;

      if ("" == customerName) return;
      var params = {
        customerName: customerName //queryType:1

      };

      var callback = function callback(req) {
        _this.customerList = req.data || [];
        _this.queryCustomerNameLoading = false;
      };

      this.queryCustomerNameLoading = true;
      this.$store.dispatch("Query-Customer-Info-For-Filte-Data", {
        params: params,
        callback: callback
      });
      /*this.$store.dispatch("Query-Customer-For-Warrant-Query-Contract", {
        params,
        callback
      });*/
    }
  }
};